import { render } from "./ContactTeaser.vue?vue&type=template&id=23dc1967"
import script from "./ContactTeaser.vue?vue&type=script&lang=js"
export * from "./ContactTeaser.vue?vue&type=script&lang=js"

import "./ContactTeaser.vue?vue&type=style&index=0&id=23dc1967&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__